import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type KnockStoreSettleType = {
  key: string;
  data: KnockStoreSettleDetailType[];
};

export type KnockStoreSettleDetailType = {
  store_id: number;
  parent_store_name: string;
  store_name: string;
  pay_company: string;
  room_tip: number;
  settlement_start_date: string;
  settlement_end_date: string;
  store_discount_amt: number;
  com_discount_amt: number;
  order_count: number;
  cancel_order_count: number;
  order_amount: number;
  delivery_price: number;
  final_payment_amt: number;
  payment_fee: number;
  relay_fee: number;
  vat: number;
  total_deductions: number;
  order_settlement_amt: number;
  scheduled_settlement_amt: number;
  cancel_amt: number;
  minus_balance: number;
  carried_balance: number;
  bank_name: string;
  account_nm: number;
  account_holder: string;
  transfer_status: number;
  completion_date: string;
  scheduled_date: string;
  email: string;
  business_number: string;
};

const SettlementController = {
  // knockknock 정산
  getKnockStoreSettlement: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getAdminSettlement';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 매장 정산 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 호텔 월정산
  getHotelMonth: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/settlement/hotel/getHotelMonth';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 호텔 월정산 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getKnockStoreSettlementDetail: async (oParams: { start_date: string; end_date: string }) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getKnockOrderDetail';
      // let sUrl = 'https://ivid-ceo-api.ivid.co.kr/api' + '/admin/getKnockOrderDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 매장 정산 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getMonthReport: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/report/getMonthReport';
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 매장 월간 리포트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getWeekReport: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/report/getWeekReport';
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 매장 주간 리포트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getDayReport: async (data: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/report/getDayReport';
      const response: any = await Axios.post(sUrl, data);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 매장 일간 리포트 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default SettlementController;
